export const roundMoney = (amount: string | number | undefined): string => {
	const floatNumber = Number.parseFloat(String(amount ?? 0)).toFixed(3);
	if (!Number.isNaN(Number(floatNumber))) {
		return floatNumber;
	}
	return String(amount ?? 0);
};
